<template>
  <div v-if="loading">
    Loading customers from store...
  </div>
  <div v-else>
      <div class="debug" data-testid="debug">
        <p>header = {{ header }}</p>
        <p>isLoading = {{ isLoading }}</p>
        <p>loading = {{ loading }}</p>
        <!--p>allCustomers.length = {{ allCustomers.length }}</p-->
        <p>tableData.length = {{ tableData.length }}</p>
        <!--p>allCustomers = {{ allCustomers }}</p-->
        <!--p>colWidths = {{ colWidths }}</p>
        <p>filtered.length = {{ filtered.length }}</p>
        <p>search = {{ search }}</p>-->
    </div>
  <FilterTable
    :header="header"
    :data="customerTableData"
    :columnWidths="colWidths"

    @rowClicked="printRow"
    v-model:filtered="filtered"
    v-model:search="search"
  >
  </FilterTable>

  <!--div class="btn-row-left">
    <FormBtn v-if="currentGroup === 'admin'" :name="'Download all Customer Data'" @clicked="downloadAllCustomers"></FormBtn>
    <FormBtn v-if="currentGroup === 'admin'" :name="'Admin Manage Customers'" @clicked="router.push('/customers/manage')"></FormBtn>
    <FormBtn :name="'Refresh Table'" @clicked="customers.fetchAllCustomers"></FormBtn>
  </div-->

  </div>


</template>

<script setup lang="ts">
import { ref, computed, onBeforeMount } from 'vue'
//import { loadingStart, loadingEnd } from '../js/common.js';
//import MyTable from '@/components/MyTable.vue';
import { useCustomerStore, useUserStore } from '@/stores'
import type { Customer } from '@/types/types'
//import { FormBtn } from '@/components/form'
import router from '@/router'
import { FilterTable } from '@/components'
import { useCustomerTableFilter } from '@/composables/Customer-table-filter'
//import { useAllCsvDownload } from '@/composables/All-csv-download'
//import { customerSchema } from '@/types/types'
import { storeToRefs } from 'pinia'

const userStore = useUserStore()
const { currentGroup } = storeToRefs(userStore)
const customers = useCustomerStore()
const { tableData, isLoading, loading } = storeToRefs(customers);

//tableData is computed/readonly, need to make a local copy here
//const CustomerTableData = ref(JSON.parse(JSON.stringify(tableData.value)));
/*const customerTableData = ref([]);
onBeforeMount(()=>{
  const customerTableData = ref(JSON.parse(JSON.stringify(tableData.value)));
})*/
/*const customerTableData = computed(()=>{
  return JSON.parse(JSON.stringify(tableData.value));
})*/
const customerTableData = ref([]);

//const allCustomers = ref<Array<Customer>>([])
const header =
  currentGroup.value === 'admin' || currentGroup.value === 'standard'
    ? [
        'id',
        'customer',
        'project count',
        'invoice count',
        'total invoiced',
        'archived',
        'notes'
      ]
    : ['id', 'customer', 'project count', 'archived', 'notes']
const colWidths = currentGroup.value === 'admin' || currentGroup.value === 'standard' ?
  [6, 12, 6, 6, 6, 6, 20] : [6, 12, 6, 6, 20]

//await fetchCustomers()
customerTableData.value = await customers.fetchTableData();


//const filteredCustomers = ref(allCustomers.value);
let searchJson = {}
header?.forEach((col) => {
  searchJson[col] = ''
})
const search = ref(searchJson)
const { filtered } = useCustomerTableFilter(customerTableData, search)
/*
const customerHeader = [
  'id',
  'created_on',
  'created_by',
  'modified_on',
  'name',
  'companyName',
  'invoiceName',
  'totalInvoiced',
  'notes',
  'email',
  'projectCount',
  'postechCount',
  'archived'
]*/
//add projectCount field to customerSchema
/*const { downloadAllCsv } = useAllCsvDownload(
  customerTableData,
  customerSchema,
  customerHeader,
  'Customers'
)*/
/*
async function downloadAllCustomers(){
 // await forceFetchCustomers();
  await customers.fetchAllCustomers();
  await downloadAllCsv();
}*/

function printRow(item: Customer) {
  console.log('customers-table.printRow..')
 // console.log(JSON.stringify(item))
  //console.log("...pushing router to project_details");
  router.push(`/customers/${item.id?.toString()}`)
}
</script>

<style lang="css" scoped>
.btn-div {
  padding: 0;
  margin-bottom: 1rem;
}
</style>
